export const placeholder = {
  myEmail: "my_email",
  clientEmails: "client_emails",
  clientName: "client_name",
  otherSalesReps: "other_sales_reps",
  myCompanyName: "my_company_name",
  clientGreetings: "client_greetings",
  quoteNumber: "quote_number",
  validityDates: "validity_dates",
  quoteSummary: "quote_summary",
  mySignature: "my_signature",
  previousEmailBody: "previous_email_body",
};

// What the user reads wherever a placeholder is offered or still unresolved - the picker, the
// chips in the editors and the recipient suggestions. The keys above stay the wire format.
export const placeholderLabel: Record<string, string> = {
  [placeholder.clientEmails]: "Account Emails",
  [placeholder.clientGreetings]: "Account Greetings",
  [placeholder.clientName]: "Account Name",
  [placeholder.myCompanyName]: "My Company Name",
  [placeholder.myEmail]: "My Email",
  [placeholder.mySignature]: "My Signature",
  [placeholder.otherSalesReps]: "Other Sales Reps",
  [placeholder.quoteNumber]: "Quote Number",
  [placeholder.quoteSummary]: "Quote Summary",
  [placeholder.previousEmailBody]: "Quoted Email",
  [placeholder.validityDates]: "Validity Dates",
};
